<button mat-icon-button class="gh-button" [matMenuTriggerFor]="menu">
  <mat-icon [matBadgeHidden]="!reminders.length" data-cy="reminders" [matBadge]="reminders.length" matBadgeColor="primary" matBadgeSize="medium">event</mat-icon>
</button>

<mat-menu #menu="matMenu" class="gh-menu">
  <mat-card (click)="$event.stopPropagation()">
    <mat-card-header data-cy="reminders-menu" class="tw-items-center">
      <mat-icon mat-card-avatar>event</mat-icon>
      <mat-card-title data-cy="reminders-header">Today's Schedule</mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="reminders && !reminders.length">
      You don't have anything scheduled today.
    </mat-card-content>
    <button mat-menu-item *ngFor="let reminder of reminders" (click)="viewBorrower(reminder.borrowerId)">
      <mat-card *ngIf="reminder">
        <mat-card-header>
          <div mat-card-avatar *ngIf="!reminder.occurred" [ngSwitch]="reminder.action" style="color: #f7cc45">
            <mat-icon *ngSwitchCase="'call'">call</mat-icon>
            <mat-icon *ngSwitchCase="'message'">message</mat-icon>
            <mat-icon *ngSwitchDefault>alarm</mat-icon>
            <mat-icon *ngIf="reminder.occurred">check_circle</mat-icon>
          </div>
          <div *ngIf="reminder.occurred">
            <mat-icon color="success">check_circle</mat-icon>
          </div>
          <mat-card-title>{{ reminder.expiresTimestamp * 1000 | date:'shortTime' }} - {{ reminder.action | titlecase }} Reminder</mat-card-title>
          <mat-card-subtitle>{{ reminder.borrower?.name }}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="reminder.reason">{{ reminder.reason }}</mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </button>
    <mat-card-footer>
      <a data-cy="weekly-schedule" [color]="'primary'" mat-button routerLink="/schedule">View Weekly Schedule</a>
    </mat-card-footer>
  </mat-card>
</mat-menu>
